import React from 'react';
import '../publishing-dialog.css';
import ResourcesIcon from '../../../assets/resources.svg';
import DatabaseIcon from '../../../assets/relational-database.png';
import HttpEndpointIcon from '../../../assets/http-endpoint.svg';
import ServerIcon from '../../../assets/server.svg';
import ContainerComputeIcon from '../../../assets/container-compute.svg';
import SharedDriveIcon from '../../../assets/shared-drive.svg';
import CloudFileSystemBucketIcon from '../../../assets/cloud-file-system.svg';
import Chip from '../../../lib/chip/Chip';
import { resolveResourceNameFromType } from '../utils';
import { EditorService } from '../../../services/editor';
import { InfrastructureResourceType } from '@elyx-code/definitions';
import {
	BaseEntityNames,
	checkHasBaseEntity
} from '@elyx-code/project-logic-tree';

interface IPublishingResourcesDetailsProps {
	details: any;
	project: EditorService;
}

const resolveResourceIconFromType = (resourceType: string) => {
	switch (resourceType) {
		case InfrastructureResourceType.RelationalDatabase:
			return DatabaseIcon;
		case InfrastructureResourceType.HttpEndpoint:
			return HttpEndpointIcon;
		case InfrastructureResourceType.ServerlessFunction:
			return ServerIcon;
		case InfrastructureResourceType.ContainerCompute:
			return ContainerComputeIcon;
		case InfrastructureResourceType.SharedDrive:
			return SharedDriveIcon;
		case InfrastructureResourceType.CloudFileSystemBucket:
			return CloudFileSystemBucketIcon;
		default:
			return ResourcesIcon;
	}
};

const PublishingResourcesDetails: React.FC<
	IPublishingResourcesDetailsProps
> = ({ details, project }) => {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
			{details.resources.map((resource: any, index: number) => (
				<div
					key={index}
					style={{
						display: 'flex',
						gap: '16px',
						alignItems: 'center'
					}}
				>
					<img
						style={{ width: '24px', height: '24px' }}
						src={resolveResourceIconFromType(resource.type)}
						alt="resource icon"
					/>
					<div>
						<div
							style={{
								display: 'flex',
								gap: '8px',
								alignItems: 'center'
							}}
						>
							<h4 style={{ margin: '0px' }}>
								{resolveResourceNameFromType(resource.type)}
							</h4>
							{resource.items.new.count > 0 && (
								<Chip>{resource.items.new.count} new</Chip>
							)}
							{resource.items.modified.count > 0 && (
								<Chip color="warning">
									{resource.items.modified.count} modified
								</Chip>
							)}
							{resource.items.deleted.count > 0 && (
								<Chip color="error">
									{resource.items.deleted.count} deleted
								</Chip>
							)}
						</div>
						<p
							style={{
								margin: '0px',
								fontSize: '12px',
								marginTop: '2px',
								color: 'rgba(0,0,0,0.54)'
							}}
						>
							{resource.type ===
							InfrastructureResourceType.RelationalDatabase
								? `${
										project.logic.entities.filter((ent) =>
											checkHasBaseEntity(
												ent,
												BaseEntityNames.PERSISTED_ENTITY
											)
										).length
									} tables in databases`
								: `${resource.items.total.count} total in project`}
						</p>
					</div>
				</div>
			))}
		</div>
	);
};

export default PublishingResourcesDetails;
